import script from "./MainModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainModal.vue?vue&type=script&setup=true&lang=js"

import "./MainModal.vue?vue&type=style&index=0&id=f891ebfa&lang=scss"

const __exports__ = script;

export default __exports__